import { InjectionToken } from '@angular/core';

export interface ScrollAdapterConfig {
    disableHorizontalScrollOnDesktop: boolean;
}

export const SCROLL_ADAPTER_CONFIG = new InjectionToken<ScrollAdapterConfig>('ms-scroll-adapter');
